export default __webpack_public_path__ + "static/yabing-e28c66009738e5be82838daf06e3d3e5.png";